<template>
  <div>
    <Form/>
  </div>
</template>

<script>
import Form from '../components/Form'


export default {
    components: {
      Form,
    }
}
</script>

<style lang="scss" scoped>
@import '../styles/style';

</style>